"use strict";
const routes = [
    {
        // 首页
        path: '/',
        name:'首页',
        component(resolve) {
            require(['../pages/index/index.vue'], resolve);
        }
    },
    {
        path:'/index',
        component(resolve){
            require(['../components/auth.vue'],resolve);
        }
    },
    {
        path:'/statute',
        name:'法规中心',
        component(resolve){
            require(['../pages/statute/statute.vue'],resolve);
        }
    },
    {
        path:'/statute-content',
        name:'',
        component(resolve){
            require(['../pages/statute/statute_content.vue'],resolve);
        }
    },
    {
        path:'/news',
        name:'新闻资讯',
        component(resolve){
            require(['../pages/news/news.vue'],resolve);
        }
    },
    {
        path:'/news-content',
        name:'',
        component(resolve){
            require(['../pages/news/news_content.vue'],resolve);
        }
    },
    {
        path:'/business',
        name:'业务服务',
        component(resolve){
            require(['../pages/business/business.vue'],resolve);
        }
    },
    {
        path:'/codex',
        name:'数据库',
        component(resolve){
            require(['../pages/codex/codex.vue'],resolve);
        }
    },
    {
        path: '/questions',
        name:'问与答',
        component(resolve) {
            require(['../pages/questions/questions.vue'], resolve);
        }
    },
    {
        path: '/questions-content',
        name:'',
        component(resolve) {
            require(['../pages/questions/questions-content.vue'], resolve);
        }
    },
    {
        path: '/term',
        name:'术语学习',
        component(resolve) {
            require(['../pages/term/term.vue'], resolve);
        }
    },
    {
        path: '/term-content',
        component(resolve) {
            require(['../pages/term/term-content.vue'], resolve);
        }
    },
    {
        path: '/about',
        component(resolve) {
            require(['../pages/user/about.vue'], resolve);
        }
    },
    {
    	path:'/personal',
    	component(resolve){
    		require(['../pages/user/personal.vue'],resolve);
    	}
    }
]
export default routes;


// WEBPACK FOOTER //
// ./src/routes/index.js